.answerContainer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 8.1285px;
  gap: 5.42px;
  background: #ffffff;
  box-shadow:
    0px 1px 2px rgba(0, 0, 0, 0.14),
    0px 0px 2px rgba(0, 0, 0, 0.12);
  border-radius: 5.419px;
  max-width: 100%;
}

.answerContainerStreaming {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 8.1285px;
  gap: 5.42px;
  background: #f8f8f8;
  box-shadow:
    0px 1px 2px rgba(0, 0, 0, 0.14),
    0px 0px 2px rgba(0, 0, 0, 0.12);
  border-radius: 5.419px;
  max-width: 100%;
  opacity: 0.85;
}

.answerText {
  font-family: "Segoe UI";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #323130;
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
  margin: 11px;
  white-space: normal;
  word-wrap: break-word;
  max-width: 800px;
  overflow-x: auto;
  overflow-wrap: anywhere;
}

.answerFooter {
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
}

.answerDisclaimerContainer {
  justify-content: center;
  display: flex;
}

.answerDisclaimer {
  font-family: "Segoe UI";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  margin-right: 5px;
  margin-left: 10px;
  padding-bottom: 5px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #707070;
  flex: none;
  order: 1;
  flex-grow: 0;
}

.citationContainer {
  margin-left: 10px;
  font-family: "Segoe UI";
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  max-width: 100%;
  color: #115ea3;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 6px;
  gap: 4px;
  border: 1px solid #d1d1d1;
  border-radius: 4px;
}

.citationContainer:hover {
  text-decoration: underline;
  cursor: pointer;
}

.citation {
  box-sizing: border-box;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;
  width: 14px;
  height: 14px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  flex: none;
  flex-grow: 0;
  z-index: 2;
  font-family: "Segoe UI";
  font-style: normal;
  font-weight: 600;
  font-size: 10px;
  line-height: 14px;
  text-align: center;
  color: #424242;
  cursor: pointer;
}

.citation:hover {
  text-decoration: underline;
  cursor: pointer;
}

.accordionIcon {
  display: inline-flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px;
  margin-top: 4px;
  color: #616161;
  font-size: 10px;
}

.accordionIcon:hover {
  cursor: pointer;
}

.accordionTitle {
  margin-right: 5px;
  margin-left: 10px;
  font-family: "Segoe UI";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  align-items: center;
  color: #616161;
}

.accordionTitle:hover {
  cursor: pointer;
}

.clickableSup {
  box-sizing: border-box;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;
  width: 14px;
  height: 14px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  flex: none;
  order: 2;
  flex-grow: 0;
  z-index: 2;
  font-family: "Segoe UI";
  font-style: normal;
  font-weight: 600;
  font-size: 10px;
  line-height: 14px;
  text-align: center;
  color: #424242;
  cursor: pointer;
}

.clickableSup:hover {
  text-decoration: underline;
  cursor: pointer;
}

sup {
  font-size: 10px;
  line-height: 10px;
}

@media (max-width: 500px) {
  .answerFooter {
    flex-direction: column;
  }

  .citationContainer {
    width: 100%;
    overflow-y: auto;
  }
}

/* High contrast mode specific styles */
@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .answerContainer {
    border: 2px solid WindowText;
    padding: 10px;
    background-color: Window;
    color: WindowText;
  }
}

.actionButtons {
  display: flex;
  align-items: center;
  margin-left: 10px;
  margin-top: 6px;
  gap: 6px;
}

.actionButton {
  font-family: "Segoe UI";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #616161;
  cursor: pointer;
  user-select: none;
}

.actionButton:hover {
  color: #115ea3;
}